<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    {{title}}
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>



            <div class="card card-style">
                <div class="content">
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight">عنوان</span>
                        <input class="form-control" type="text" v-model="NoticeMassageUser.Title">
                    </div>


                    <div class="mb-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" v-on:change="onChangeType(false)" :checked="!NoticeMassageUser.Type" name="inlineRadioOptions" id="inlineRadio1" value="option1">
                            <label class="form-check-label mx-1" for="inlineRadio1">اعلان</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" v-on:change="onChangeType(true)" :checked="NoticeMassageUser.Type" name="inlineRadioOptions" id="inlineRadio2" value="option2">
                            <label class="form-check-label mx-1" for="inlineRadio2">رویداد</label>
                        </div>
                    </div>
                    <div v-if="NoticeMassageUser.Type">
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.CreateDate!==null}">تاریخ شروع روز شمار</span>
                            <input type="text" v-model="NoticeMassageUser.CreateDate" id="CreateDateDT" />
                        </div>
                        <date-picker type="date" v-model="NoticeMassageUser.CreateDate" format="jYYYY/jMM/jDD" element="CreateDateDT" />
                    </div>
                    <div v-if="NoticeMassageUser.Type">
                        <div class="mb-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-clock pl-2 color-magenta2-light"></i>
                                    <label class="mb-0 font-12 font-weight-bold">زمان شروع روز شمار</label>
                                </div>
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                        <span class="font-13 font-weight-bold px-3"></span>
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                    </div>
                                    <div class="ltr">
                                        <input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(NoticeMassageUser.CreateTimeHour > 23 || NoticeMassageUser.CreateTimeHour < 0) { NoticeMassageUser.CreateTimeHour = ''}}" style="max-width:60px" type="tel" maxlength="2" max="23" v-model="NoticeMassageUser.CreateTimeHour">
                                        <span class="font-13 font-weight-bold px-2">:</span>
                                        <input placeholder="00" @input="() => { if(NoticeMassageUser.CreateTimeMinute > 59 || NoticeMassageUser.CreateTimeMinute < 0) { NoticeMassageUser.CreateTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="NoticeMassageUser.CreateTimeMinute">
                                        <!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span v-if="NoticeMassageUser.Type" class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.ViewDate!==null}">تاریخ رویداد</span>
                            <span v-else class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.ViewDate!==null}">تاریخ اعلان</span>
                            <input type="text" v-model="NoticeMassageUser.ViewDate" id="endDT" />
                        </div>
                        <date-picker type="date" v-model="NoticeMassageUser.ViewDate" format="jYYYY/jMM/jDD" element="endDT" />
                    </div>

                    <div class="mb-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-clock pl-2 color-magenta2-light"></i>
                                <label v-if="NoticeMassageUser.Type" class="mb-0 font-12 font-weight-bold">زمان رویداد</label>
                                <label v-else class="mb-0 font-12 font-weight-bold" id="txtViewTime">زمان اعلان</label>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex justify-content-between align-items-center">
                                    <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                    <span class="font-13 font-weight-bold px-3"></span>
                                    <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                </div>
                                <div class="ltr">
                                    <input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(NoticeMassageUser.ViewTimeHour > 23 || NoticeMassageUser.ViewTimeHour < 0) { NoticeMassageUser.ViewTimeHour = ''}}" style="max-width:60px" type="tel" maxlength="2" max="23" v-model="NoticeMassageUser.ViewTimeHour">
                                    <span class="font-13 font-weight-bold px-2">:</span>
                                    <input placeholder="00" @input="() => { if(NoticeMassageUser.ViewTimeMinute > 59 || NoticeMassageUser.ViewTimeMinute < 0) { NoticeMassageUser.ViewTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="NoticeMassageUser.ViewTimeMinute">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight">آدرس وب</span>
                        <input class="form-control ltr text-left" type="text" v-model="NoticeMassageUser.WebUrl">
                    </div>
                    <div class="input-style input-style-2 has-icon input-required mb-0">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight ltr">توضیحات</span>
                        <textarea v-model="NoticeMassageUser.Description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>


                    </div>
                    <button class="btn btn-link speechToTextBtn mb-3 mt-3" @pointerdown="startR"
                            @pointerup="stopR">
                        <span :class="btnRecord">
                            <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                        </span>
                        <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                    </button>

                    <div class="mb-3">
                        <p class="p-2 text-justify pt-0" v-if="isMinVersion">
                            در این لیست فقط
                            <b class="text-danger">کابران دارای اشتراک</b>
                            قابل مشاهده هستند. برای دسترسی به
                            <b>لیست تمام کاربران</b>
                            به قسمت
                            <b class="text-danger">خرید اشتراک</b>
                            مراجعه نمایید.
                        </p>
                        <div class="scrollableBox400">
                            <div class="py-2 borderedListBox" v-for="user in LocalUserListList" :key="user.userId">
                                <div class="d-flex align-items-center justify-content-start">
                                    <input :disabled="user.expired" class="big-checkbox UserSelected" type="checkbox" :value="user.userId" :id="user.userId" :key="user.userId" />
                                    <div class="w-100 pr-3">
                                        <div><i class="fa fa-user color-magenta2-light ml-3"></i> <b>{{user.userTitle}}</b></div>
                                        <div v-if="isMinVersion==false"><i class="fa fa-hashtag color-magenta2-light ml-3"></i>کد واحد سازمانی: <b>{{user.orgJobCode}}</b></div>
                                        <div v-if="isMinVersion==false"><i class="fa fa-address-card color-magenta2-light ml-3"></i> عنوان واحد سازمانی: <b>{{user.orgJobTitle}}</b></div>
                                        <div><i class="fa fa-hashtag color-magenta2-light ml-3"></i>کد پست سازمانی: <b>{{user.orgJobCode}}</b></div>
                                        <div><i class="fa fa-address-card color-magenta2-light ml-3"></i>عنوان پست سازمانی: <b>{{user.orgJobTitle}}</b></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                    <button :disabled="pageLoading" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="CreateNoticeMassageUser">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                    <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required, between
    } from "@vuelidate/validators";
    import { maska } from 'maska';
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            DatePicker
        },
        data() {
            return {
                title: "افزودن اعلان",
                TypeTitle: "اعلان",
                pageLoading: true,
                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",

                NoticeMassageUser: {
                    NoticeMessageId: 0,
                    NoticeMessageUsersJson: null,
                    NoticeMessageUsers: [],
                    ViewDate: null,
                    ViewTime: null,
                    CreateDate: null,
                    CreateTime: null,
                    mod: false,
                    CreateTimeHour: null,
                    CreateTimeMinute: null,
                    ViewTimeHour: null,
                    ViewTimeMinute: null,
                    Title: null,
                    WebUrl: null,
                    MobileUrl: null,
                    Description: null,
                    Type: false,
                }
            }
        },
        methods: {
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            onChangeType(type) {
                this.NoticeMassageUser.Type = type;
                if (type) {
                    this.title = "افزودن رویداد";
                    this.TypeTitle = "رویداد";
                } else {
                    this.title = "افزودن اعلان";
                    this.TypeTitle = "اعلان";
                }
            },
            CreateNoticeMassageUser() {



                if (this.NoticeMassageUser.Title == null || this.NoticeMassageUser.Title == "") {
                    this.showErrorMessage("عنوان را وارد کنید");
                    return;
                }
                if (this.NoticeMassageUser.ViewDate == null || this.NoticeMassageUser.ViewDate == "") {
                    this.showErrorMessage("تاریخ " + this.TypeTitle + " را وارد کنید");
                    return;
                }

                if ((this.NoticeMassageUser.ViewTimeHour == null || this.NoticeMassageUser.ViewTimeHour == "") && (this.NoticeMassageUser.ViewTimeMinute == null || this.NoticeMassageUser.ViewTimeMinute == "")) {
                    this.showErrorMessage("زمان " + this.TypeTitle + " معتبر نیست");
                    return;
                }
                if (this.NoticeMassageUser.Type) {
                    if (this.NoticeMassageUser.CreateDate == null || this.NoticeMassageUser.CreateDate == "") {
                        this.showErrorMessage("تاریخ شروع روز شمار معتبر نیست");
                        return;
                    }

                    if ((this.NoticeMassageUser.CreateTimeHour == null || this.NoticeMassageUser.CreateTimeHour == "") && (this.NoticeMassageUser.CreateTimeMinute == null || this.NoticeMassageUser.CreateTimeMinute == "")) {
                        this.showErrorMessage("زمان شروع روز شمار معتبر نیست");
                        return;
                    }

                    if ((this.NoticeMassageUser.CreateTimeHour == null || this.NoticeMassageUser.CreateTimeHour == ""))
                        this.NoticeMassageUser.CreateTimeHour = "00";

                    if ((this.NoticeMassageUser.CreateTimeMinute == null || this.NoticeMassageUser.CreateTimeMinute == ""))
                        this.NoticeMassageUser.CreateTimeMinute = "00";
                    this.NoticeMassageUser.CreateTime = this.NoticeMassageUser.CreateTimeHour + ":" + this.NoticeMassageUser.CreateTimeMinute;

                } else {
                    this.NoticeMassageUser.CreateDate = null;
                    this.NoticeMassageUser.CreateTime = null;
                    this.NoticeMassageUser.CreateTimeHour = null;
                    this.NoticeMassageUser.CreateTimeMinute = null;
                }


                if ((this.NoticeMassageUser.ViewTimeHour == null || this.NoticeMassageUser.ViewTimeHour == ""))
                    this.NoticeMassageUser.ViewTimeHour = "00";

                if ((this.NoticeMassageUser.ViewTimeMinute == null || this.NoticeMassageUser.ViewTimeMinute == ""))
                    this.NoticeMassageUser.ViewTimeMinute = "00";
                this.NoticeMassageUser.ViewTime = this.NoticeMassageUser.ViewTimeHour + ":" + this.NoticeMassageUser.ViewTimeMinute;


                let checkBox = document.getElementsByClassName("UserSelected");
                let userIds = [];
                let users = [];
                if (checkBox.length > 0) {
                    for (var i = 0; i < checkBox.length; i++) {
                        if (checkBox[i].checked) {
                            userIds.push(checkBox[i].value);
                        }
                        let user = {
                            Selected: userIds.includes(checkBox[i].value),
                            UserId: checkBox[i].value,
                        };
                        users.push(user);
                    }
                }
                if (userIds.length == null || userIds.length <= 0) {
                    this.showErrorMessage("هیچ کاربری انتخاب نشده است");
                    return;
                }
                this.NoticeMassageUser.NoticeMessageUsersJson = userIds.join(",");
                this.NoticeMassageUser.NoticeMessageUsers = users;
                this.pageLoading = true;
                this.$http.post("NoticeMassageUser/Create", this.NoticeMassageUser)
                    .then(data => {
                        this.pageLoading = false;
                        var res = data.data;

                        if (res.isSuccess) {
                            this.showSuccessMessage(res.message);
                            this.goBack();
                        } else {
                            this.showErrorMessage(res.message);
                        }
                    });

            }

            , GetNoticeMassageUserList() {
                this.pageLoading = true;
                this.$http
                    .get("NoticeMassageUser/NotificationMessageUser?id=0")
                    .then((data) => {
                        var res = data.data;
                        this.NoticeMassageUser.NoticeMessageUsers = res;
                        this.pageLoading = false;
                    });

            },
        },
        computed: {
            LocalUserListList() {
                return this.NoticeMassageUser.NoticeMessageUsers;
            },
        },
        created() {
            let type = this.$route.params.type;
            if (type === "true") {
                this.NoticeMassageUser.Type = true;
            }

            this.onChangeType(this.NoticeMassageUser.Type);
            this.$store.dispatch("CheckUserSMS");
            this.GetNoticeMassageUserList();

        },
        mounted() {
            this.pageLoading = false;
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.NoticeMassageUser.Description == null || this.NoticeMassageUser.Description == "null")
                        this.NoticeMassageUser.Description = "";
                    if (rest != null && rest != '')
                        this.NoticeMassageUser.Description = this.NoticeMassageUser.Description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }

        },
        validations: {
            NoticeMassageUser: {
                ViewDate: {
                    required,
                },
                ViewTime: {
                    required
                },
                Title: {
                    required
                }
            }
        },
        directives: { maska },
    }
</script>